import React from "react";
import { LayoutDashboard, Users, BookMarked, MessagesSquare } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import logo from "../../Assets/Images/WhatsApp Image 2025-08-07 at 11.34.45 AM.jpeg";

const navItems = [
  { name: "Dashboard", href: "/adminpanel/dashboard", icon: <LayoutDashboard size={20} /> },
  { name: "Contact Form", href: "/adminpanel/dashboard/contact", icon: <Users size={20} /> },
  { name: "Careers Form", href: "/adminpanel/dashboard/get-in-touch", icon: <MessagesSquare size={20} /> },
  { name: "Job Opening", href: "/adminpanel/dashboard/jobs", icon: <MessagesSquare size={20} /> },
  { name: "Insights", href: "/adminpanel/dashboard/blogs", icon: <BookMarked size={20} /> },
];

const Sidebar = () => {
  const location = useLocation();

  return (
    <aside className="fixed left-0 top-0 h-full w-64 bg-white shadow-md flex flex-col z-40">
      {/* Logo */}
      <div className="h-16 flex items-center justify-center border-b">
        <img src={logo} alt="Logo" className="h-10 object-contain" />
      </div>

      {/* Nav Links */}
      <nav className="flex-1 px-3 py-4 space-y-2 overflow-y-auto">
        {navItems.map((item) => (
          <Link
            key={item.name}
            to={item.href}
            className={`flex items-center gap-3 px-4 py-2 rounded-lg transition ${
              location.pathname === item.href
                ? "bg-purple-100 text-purple-700 font-medium"
                : "text-gray-600 hover:bg-gray-100"
            }`}
          >
            {item.icon}
            <span>{item.name}</span>
          </Link>
        ))}
      </nav>
    </aside>
  );
};

export default Sidebar;
